import { IPage, ISearchPage } from '@/types/AppTypes'
import { httpRequest } from '@/utils/HttpRequest'
import { getBaseCiRequestUrl, getToken } from '@/utils/constants'
import { BillTotalResult, BillDetailResult } from './settleTypes'

class SettleService {

    async total(searchVo: any) {
        const apiUrl = '/yh-franchisee/franchiseeBill/list'
        return await httpRequest.post<IPage<BillTotalResult>>(apiUrl, searchVo, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }

    async detail(searchVo: any) {
        const apiUrl = '/yh-franchisee/order/bill_platform_list'
        return await httpRequest.post<IPage<BillDetailResult>>(apiUrl, searchVo, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }

    async one(id: string) {
        const apiUrl = `/yh-franchisee/franchiseeBill/one/${id}`
        return await httpRequest.get<any>(apiUrl, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }

    async audit(params: any) {
        const apiUrl = '/yh-franchisee/franchiseeBill/audit'
        return await httpRequest.post<boolean>(apiUrl, params, { baseURL: getBaseCiRequestUrl(), token: getToken() });
    }

    async deleteInvoice(id: string) {
        const apiUrl = `/yh-franchisee/franchiseeBillInvoice/delete/${id}`
        return await httpRequest.get<any>(apiUrl, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }
}

export const settleService = new SettleService()

